import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { tabs } from './tabConfig';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    tenantTabs: {
      [SERVICE_PROVIDERS.SPIREON]: () => tabs.tenantTabs[SERVICE_PROVIDERS.SPIREON],
      default: () => tabs.tenantTabs['default'],
    },
    udAssignEntryList_calHt: {
      [SERVICE_PROVIDERS.CLUTCH]: () => 165,
      [SERVICE_PROVIDERS.RADIUS]: () => 165,
      [SERVICE_PROVIDERS.TWOBRO]: () => 165,
      [SERVICE_PROVIDERS.TTS]: () => 165,
      [SERVICE_PROVIDERS.WEBFLEET]: () => 165,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => 165,
      [SERVICE_PROVIDERS.NAUTO]: () => 165,
      default: () => 130,
    },
    udAssignEntryList_calHtMul: {
      [SERVICE_PROVIDERS.CLUTCH]: () => 52,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => 52,
      default: () => 45,
    },
    udLogTable_generateRows: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    udLogTable_itemsPerPage: {
      [SERVICE_PROVIDERS.SPIREON]: () => 10,
      default: () => 15,
    },
    udcheckWrapper: {
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      default: () => false,
    },

    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
